import PreviousArrow from '@/SVG/PreviousArrow'
import Button from '@/components/Button'
import { useChapter } from '@/context/ChapterContext'

export default function PreviousChapter() {
  const { isChangingChapter, previousChapter, currentChapterNumber: currentChapter } = useChapter()

  const handlePreviousChapter = () => {
    console.log('Navigating to previous chapter', 'navigation')
    previousChapter()
  }

  return (
    <Button small onClick={handlePreviousChapter} disabled={isChangingChapter || currentChapter === 0}>
      <PreviousArrow />
    </Button>
  )
}

export { PreviousChapter }
